import config from 'config';
import sfax from './sfax';
const { graphqlDomain } = config;

function joinEqul(params) {
    let paramsList = [];
    for (let key in params) {
        paramsList.push(`${key}=${params[key]}`)
    }
    return paramsList.join('&')
}

function fetchDataNormal({path, query}) {
    return sfax({
        url: `${graphqlDomain}/alias/query`,
        data: {
            name: path,
            graphProjectId: 6,
            param: joinEqul(query)
        },
        withCredentials: true,
        jsonp: true,
        callbackname: 'function'
    })
}

export default fetchDataNormal


// WEBPACK FOOTER //
// ./src/model/api/graphql.js